import React from 'react';

export function useRemoveIndexFromArray<V = unknown>(
    setState: React.Dispatch<React.SetStateAction<V[]>>,
): (item: V, index: number) => void {
    return React.useCallback(
        (_item, index) => setState(values => [...values.slice(0, index), ...values.slice(index + 1)]),
        [setState],
    );
}
